module.exports = __webpack_public_path__ + "img/1.513359c3.png";